import styled from "@emotion/styled";
import {
  grayScale,
  mBody1,
  mBody2,
  mBody3,
  mBody4,
  mCaption1,
  mHeader0,
  mHeader1,
  mTitle2,
  sparta,
  swc,
  wBody1,
  wBody2,
  wBody3,
  wBody4,
  wHeader1,
  wHeader2,
  wTitle4,
} from "@teamsparta/design-system";
import { DESKTOP, forDesktop } from "@/themes/device";

export const Background = styled.section`
  background-color: ${grayScale.gray100};
  padding: 60px 16px;
  ${DESKTOP} {
    padding: 100px 0 100px;
  }
`;

export const Wrapper = styled.section`
  width: 328px;
  margin: 0 auto;
  gap: 32px;
  ${DESKTOP} {
    display: flex;
    width: initial;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    gap: 48px;
  }
`;

export const TextAndButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
  ${DESKTOP} {
    display: flex;
    max-width: 374px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 40px;
    flex: 1 0 0;

    button {
      margin: 0;
    }
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;

  ${DESKTOP} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const EndWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;

  ${mBody2}
  color: ${grayScale.gray30};

  ${DESKTOP} {
    display: flex;
    width: 374px;
    ${wBody2}
    color: ${grayScale.gray30};
  }
`;

export const EndLine = styled.div`
  height: 1px;
  flex: 1 0 0;

  background: ${grayScale.gray90};

  ${DESKTOP} {
  }
`;

export const SubTitle = styled.h2`
  ${mTitle2};
  color: ${grayScale.gray50};
  text-align: left;

  ${DESKTOP} {
    ${wTitle4};
    color: ${grayScale.gray50};
    text-align: left;
  }
`;

export const Title = styled.h1`
  ${mHeader1};
  color: ${grayScale.white};
  text-align: left;

  ${DESKTOP} {
    ${wHeader2};
    color: ${grayScale.white};
    text-align: left;
  }
`;

export const MobileBackgroundImage = styled.div`
  width: 328px;
  height: 244px;
  margin-bottom: 20px;
  ${DESKTOP} {
    display: none;
  }
`;

export const DesktopBackgroundImage = styled.div`
  display: none;
  ${DESKTOP} {
    display: flex;
    width: 374px;
    height: 481px;
  }
`;

export const InformationWrapper = styled.div<{ isAlimSeason }>`
  display: flex;
  padding: 20px;
  height: ${(props) => (props.isAlimSeason ? "204px" : "171px")};
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;

  border-radius: 12px;
  border: 1px solid var(--gray-gray-90-day, #3a3e41);
  background: rgba(255, 255, 255, 0.04);

  ${DESKTOP} {
    display: flex;
    width: 374px;
    height: ${(props) => (props.isAlimSeason ? "248px" : "206px")};
    padding: 24px 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
  }
`;

export const InformationLine = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 20px;
  align-self: stretch;

  ${DESKTOP} {
  }
`;

export const InformationHeadTitle = styled.div`
  ${mBody1}
  color: ${grayScale.gray5};
  ${DESKTOP} {
    ${wBody1}
    color: ${grayScale.gray5};
  }
`;

export const InformationTitle = styled.div`
  ${mBody4}
  color: ${grayScale.gray60};
  align-self: flex-start;
  ${DESKTOP} {
    min-width: 52px;
    ${wBody4}
    color: ${grayScale.gray60};
  }
`;

export const InformationContent = styled.div`
  ${mBody3}
  color: ${grayScale.gray30};
  white-space: pre-wrap;
  ${DESKTOP} {
    ${wBody3}
    color: ${grayScale.gray30};
  }
`;

export const InformationSubContent = styled.div`
  ${mBody3}
  color: ${sparta.blue100};
  margin-left: -12px;
  ${DESKTOP} {
    ${wBody3}
    color: ${sparta.blue100};
  }
`;

export const InformationTimer = styled.div`
  ${mBody3}
  color: ${sparta.blue100};
  margin-left: -16px;
  ${DESKTOP} {
    ${wBody3}
    color: ${sparta.blue100};
  }
`;

export const CtaWrapper = styled.div`
  width: 100%;
  ${DESKTOP} {
    width: 100%;
  }
`;

export const Cta = styled.div`
  display: flex;
  height: 54px;
  padding: 16px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  width: 328px;
  cursor: pointer;

  border-radius: 8px;
  background: ${swc.blue};

  ${mTitle2}
  color: ${grayScale.white};

  ${DESKTOP} {
    display: flex;
    height: 60px;
    padding: 16px 20px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    width: 374px;

    border-radius: 8px;
    background: ${swc.blue};

    ${wBody1}
    color: ${grayScale.white};
  }
`;
